"use strict";

exports.__esModule = true;
exports.SET_IS_MINI_SWITCH_VISIBILITY = exports.SET_IS_MOBILE_MENU_OPEN = exports.SET_IS_MENU_OPEN = exports.SET_IS_MINI_MODE = exports.SET_IS_AUTH_MENU_OPEN = void 0;
var SET_IS_AUTH_MENU_OPEN = 'SET_IS_AUTH_MENU_OPEN';
exports.SET_IS_AUTH_MENU_OPEN = SET_IS_AUTH_MENU_OPEN;
var SET_IS_MINI_MODE = 'SET_IS_MINI_MODE';
exports.SET_IS_MINI_MODE = SET_IS_MINI_MODE;
var SET_IS_MENU_OPEN = 'SET_IS_MENU_OPEN';
exports.SET_IS_MENU_OPEN = SET_IS_MENU_OPEN;
var SET_IS_MOBILE_MENU_OPEN = 'SET_IS_MOBILE_MENU_OPEN';
exports.SET_IS_MOBILE_MENU_OPEN = SET_IS_MOBILE_MENU_OPEN;
var SET_IS_MINI_SWITCH_VISIBILITY = 'SET_IS_MINI_SWITCH_VISIBILITY';
exports.SET_IS_MINI_SWITCH_VISIBILITY = SET_IS_MINI_SWITCH_VISIBILITY;